import React, { FC } from "react";
import Image from "next/image";

import HeroButton from "@components/HeroButton";

interface OdooHeaderProps {
    pageTitle?: string;
    mainTitle?: string;
    description?: string;
    buttonText?: string;
    imageUrl?: string;
}

const OdooHeader: FC<OdooHeaderProps> = ({
    pageTitle = "WhatsApp Odoo Integration",
    mainTitle = "Odoo WhatsApp Integration for Efficient Business Operations",
    description = "Deliver customer value faster, streamline business communication, and be more productive with seamless integration between your Odoo CRM and WhatsApp API",
    buttonText = "Start a Free Trial",
    imageUrl = "https://assets.gallabox.com/gb-home/odoo/header.png",
}) => {
    return (
        <header className="max-w-6xl mx-auto px-4 lg:px-0 pt-4  bg-white ">
            <div className="flex flex-col lg:flex-row justify-center md:justify-between lg:py-20 pt-0 mt-10">
                <div className="lg:w-6/12 w-full flex flex-col">
                    <div
                        className="text-green-700 bg-green-100 wati-top-green justify-center items-center lg:text-base font-bold flex flex-nowrap w-fit m-auto md:m-0"
                        style={{ padding: "1px 12px", borderRadius: "50px", border: "0.5px solid rgb(9, 146, 80)" }}
                    >
                        <p className="lg:text-base text-xs pr-1">{pageTitle}</p>
                        <span className="wa-control-img">
                            <Image
                                alt="white-border"
                                height={24}
                                loading="lazy"
                                width={24}
                                src="https://assets.gallabox.com/gb-home/new-zapier/wa-w-whiteborder.svg"
                                className="ml-2"
                            />
                        </span>
                    </div>
                    <h1 className="flex flex-col lg:justify-start justify-center text-gray-600 lg:pt-4 lg:text-4xl lg:font-bold text-3xl  md:text-left text-center mt-2">
                        {mainTitle}
                    </h1>
                    <p className="lg:py-6 py-4 lg:text-l font-normal text-center lg:text-left lg:text-gray-700 text-gray-600">{description}</p>

                    <HeroButton buttontext={buttonText} />

                    <div className="flex gap-4 px-2 lg:px-0 mt-6">
                        {["No setup fee", "No credit card required"].map((each) => {
                            return (
                                <div className="flex items-center gap-1 md:gap-2" key={each}>
                                    <img src="https://assets.gallabox.com/gb-home/content-with-image/grey-tick-circle.svg" alt="Gray checkmark" className="opacity-50" />
                                    <p className="head-points text-gray-400">{each}</p>
                                </div>
                            );
                        })}
                    </div>
                </div>
                <div className="lg:w-1/2 w-full">
                    <Image width={555} height={485} loading="lazy" src={imageUrl} alt="odoo-header-image" />
                </div>
            </div>
        </header>
    );
};

export default OdooHeader;
